var map = {
	"./locale-provider/ar_EG.tsx": 672,
	"./locale-provider/bg_BG.tsx": 679,
	"./locale-provider/ca_ES.tsx": 692,
	"./locale-provider/cs_CZ.tsx": 709,
	"./locale-provider/da_DK.tsx": 708,
	"./locale-provider/de_DE.tsx": 707,
	"./locale-provider/el_GR.tsx": 706,
	"./locale-provider/en_GB.tsx": 705,
	"./locale-provider/en_US.tsx": 669,
	"./locale-provider/es_ES.tsx": 704,
	"./locale-provider/et_EE.tsx": 703,
	"./locale-provider/fa_IR.tsx": 702,
	"./locale-provider/fi_FI.tsx": 701,
	"./locale-provider/fr_BE.tsx": 700,
	"./locale-provider/fr_FR.tsx": 699,
	"./locale-provider/he_IL.tsx": 698,
	"./locale-provider/hi_IN.tsx": 697,
	"./locale-provider/hu_HU.tsx": 696,
	"./locale-provider/id_ID.tsx": 695,
	"./locale-provider/is_IS.tsx": 694,
	"./locale-provider/it_IT.tsx": 693,
	"./locale-provider/ja_JP.tsx": 670,
	"./locale-provider/kn_IN.tsx": 691,
	"./locale-provider/ko_KR.tsx": 690,
	"./locale-provider/ku_IQ.tsx": 689,
	"./locale-provider/mn_MN.tsx": 688,
	"./locale-provider/nb_NO.tsx": 687,
	"./locale-provider/nl_BE.tsx": 686,
	"./locale-provider/nl_NL.tsx": 685,
	"./locale-provider/pl_PL.tsx": 684,
	"./locale-provider/pt_BR.tsx": 683,
	"./locale-provider/pt_PT.tsx": 682,
	"./locale-provider/ru_RU.tsx": 681,
	"./locale-provider/sk_SK.tsx": 680,
	"./locale-provider/sl_SI.tsx": 710,
	"./locale-provider/sr_RS.tsx": 678,
	"./locale-provider/sv_SE.tsx": 677,
	"./locale-provider/th_TH.tsx": 676,
	"./locale-provider/tr_TR.tsx": 675,
	"./locale-provider/uk_UA.tsx": 674,
	"./locale-provider/vi_VN.tsx": 673,
	"./locale-provider/zh_CN.tsx": 711,
	"./locale-provider/zh_TW.tsx": 671
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 668;